import React from 'react';
import { FileUploadContextType } from './types';

export const FilesUploadContext = React.createContext<FileUploadContextType>({} as FileUploadContextType);

export const useFilesUpload = () => React.useContext(FilesUploadContext);
